import src from "IMAGE";
export default { src, width: 763, height: 429, blurWidth: 0, blurHeight: 0};
